import styled from 'styled-components'

import CustomTheme from 'theme'

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 34px;
    position: relative;
    height: 30px;

    img {
        width: 100%;
        max-width: 62px;
        display: block;
    }

    .button-go-back {
        position: absolute;
        left: 0;

        ${CustomTheme.breakPoint.desktop} {
            display: none;
        }
    }
`
